<!--    Made by Erik Terwan    -->
<!--   24th of November 2015   -->
<!--        MIT License        -->
<nav id="header" role="navigation" class="row mx-0 px-0">
  <div class="header-logo "><a routerLink="/homepage" routerLinkActive="active" ><img src="assets/img/fisheasylogo_blue.png" ></a></div>

  <div id="menuToggle" >
    <!--
    A fake / hidden checkbox is used as click reciever,
    so you can use the :checked selector on it.
    -->
    <input type="checkbox" id="check"/>

    <!--
    Some spans to act as a hamburger.

    They are acting like a real hamburger,
    not that McDonalds stuff.
    -->
    <span></span>
    <span></span>
    <span></span>

    <!--
    Too bad the menu has to be inside of the button
    but hey, it's pure CSS magic.
    -->
    <ul id="menu">
      <a routerLink="/homepage" routerLinkActive="active"><li i18n>HOME</li></a>
      <a routerLink="/menu" routerLinkActive="active"><li i18n>MENU</li></a>

      <a routerLink="/fisheasy" routerLinkActive="active"><li i18n>FISHEASY</li></a>
      <a routerLink="/materie-prime" routerLinkActive="active"><li i18n id="checkLingua">MATERIE PRIME</li></a>
      <a routerLink="/easy-bar" routerLinkActive="active"><li i18n>COCKTAILS & HAPPY HOURS</li></a>
      <a routerLink="/easy-at-home" routerLinkActive="active"><li i18n>EASY AT HOME</li></a>
      <a routerLink="/lavora-con-noi" routerLinkActive="active"><li i18n>LAVORA CON NOI</li></a>
      <a routerLink="/contatti" routerLinkActive="active"><li i18n>CONTATTI</li></a>
    </ul>
  </div>

  <div class="cambialingua" [innerHTML]="cambiaLingua"></div>
</nav>







<div class="super-cont" [@routeAnimations]="prepareRoute(outlet)" >
  <router-outlet #outlet="outlet"></router-outlet>
</div>


<div class="footer-cont w-100 ">

  <app-footer></app-footer>

</div>
